import { render } from "./DetailEditor.vue?vue&type=template&id=cb8fcd3c"
import script from "./DetailEditor.vue?vue&type=script&lang=js"
export * from "./DetailEditor.vue?vue&type=script&lang=js"

import "./DetailEditor.vue?vue&type=style&index=0&id=cb8fcd3c&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__